"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateNestedType = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
function ValidateNestedType(typeFunction, validationOptions) {
    const typeFn = (0, class_transformer_1.Type)(typeFunction);
    const validateNestedFn = (0, class_validator_1.ValidateNested)(validationOptions);
    return (target, propertyKey) => {
        typeFn(target, propertyKey.toString());
        validateNestedFn(target, propertyKey);
    };
}
exports.ValidateNestedType = ValidateNestedType;
//# sourceMappingURL=validate-nested-type.js.map